import { useState } from "react";
import { Glasses, LogOut } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

export const ImpersonationBanner = () => {
  const { user } = useAuth();
  const [leaving, setLeaving] = useState(false);
  const imp = user?.impersonation;
  if (!imp?.active) return null;

  const stop = async () => {
    setLeaving(true);
    try {
      await api.post("/auth/impersonate/stop");
      window.location.assign("/dashboard/users");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "No se pudo salir de la vista");
      setLeaving(false);
    }
  };

  return (
    <div
      data-testid="impersonation-banner"
      className="sticky top-0 z-40 bg-amber-400 text-amber-950 border-b border-amber-500"
    >
      <div className="flex flex-wrap items-center justify-between gap-2 px-4 sm:px-6 py-2">
        <div className="flex items-center gap-2 text-sm font-medium min-w-0">
          <Glasses className="h-4 w-4 shrink-0" />
          <span className="truncate">
            Estás viendo la plataforma como <strong>{user?.name || user?.email}</strong> · solo lectura
          </span>
        </div>
        <button
          type="button"
          onClick={stop}
          disabled={leaving}
          data-testid="impersonation-exit-btn"
          className="inline-flex items-center gap-1.5 rounded-full bg-amber-950 text-amber-50 px-3 py-1.5 text-xs font-semibold hover:bg-amber-900 transition-colors disabled:opacity-60"
        >
          <LogOut className="h-3.5 w-3.5" />
          Volver a mi cuenta
        </button>
      </div>
    </div>
  );
};

export default ImpersonationBanner;
